window.reviewsOverlaySmall = function reviewsOverlaySmall() {
    $('.js_reviewOverlay').mtcOverlay({
        buttonHtml: '<div class="videoCloseButton reviewOverlayClose overlayCloseButton"><a href="#"><i class="fa fa-remove"></i> Close</a></div>'
    });
};

window.fullReviewsOverlay = function fullReviewsOverlay() {
    $('.js_fullReviewOverlay').mtcOverlay({
        buttonHtml: '<div class="videoCloseButton overlayCloseButton"><a href="#"><i class="fa fa-remove"></i> Close</a></div>'
    });
};

$(document).ready(function () {
    'use strict';

    fullReviewsOverlay();

/* -----------------------------
 *  reviews overlay
 -----------------------------*/

    $('.js_reviewOverlay').mtcOverlay({
        buttonHtml: '<div class="videoCloseButton reviewOverlayClose overlayCloseButton"><a href="#"><i class="fa fa-remove"></i> Close</a></div>',
        onOpen: function () {
            var windowHeight = $(window).height(),
                overlayHeight = (windowHeight);

            if ($(window).width() < window.breakpoints.mobile) {

                $('.overlayBox .iframeWrap').height(overlayHeight);
                $('.overlayBox').css({
                    'top': 0,
                    'left': 0,
                    'width': '100%'
                });
            }
        }
    });
});